export default __webpack_public_path__ + "static/mobileBackground-b2aaa5af4bf00e9097def110b2334d06.jpg";